import * as React from 'react';
import { observer } from 'mobx-react';
import { UIState } from 'data/UIState';
import { IconButton } from 'components/widgets/IconButton';
import {MainStageData, MainStageEvent} from "data/MainStageData";
import {MainStageEventWidget} from "components/mainstage/MainStageEventWidget";


import './MainStageEventsBar.pcss';
import {computed, observable} from "mobx";
import {Icon} from "components/widgets/icons";
import {PageEnums} from "components/nav/PageEnums";


@observer
export class MainStageEventsBar extends React.Component {

  @computed
  get barWidth() {
    return UIState.windowWidth - (UIState.windowWidth>900 ? 240  : 0);
  }

  @computed
  get visibleEventCount() {
    let show = 1;
    if(this.barWidth>2140) {
      show = 8;
    } else if(this.barWidth>1890) {
      show = 7;
    } else if(this.barWidth>1640) {
      show = 6;
    } else if(this.barWidth>1390) {
      show = 5;
    } else if(this.barWidth>1140) {
      show = 4;
    } else if(this.barWidth>880) {
      show = 3;
    } else if(this.barWidth>650) {
      show = 2;
    }
    return show;
  }

  @computed
  get moreEventsCount() {
    if(this.upcomingMainStageEvents.length>this.visibleEventCount) {
      return this.upcomingMainStageEvents.length-this.visibleEventCount;
    } else {
      return 0;
    }
  }

  @computed get moreEventsNote() {
    return this.moreEventsCount+" more session"+(this.moreEventsCount>1?'s':'');
  }

  @computed get upcomingMainStageEvents() {
    const mainStageEvents:MainStageEvent[] = [];
    let begin = false;
    MainStageData.mainStageEvents.forEach(event=>{
      if(!begin) {
        if(event.isLive || event.isNext) {
          begin = true;
        }
      }
      if(begin) {
        mainStageEvents.push(event);
      }
    });
    return mainStageEvents;
  }

  @computed get mainStageEvents() {

    if(this.upcomingMainStageEvents.length>this.visibleEventCount) {
      return this.upcomingMainStageEvents.slice(0,this.visibleEventCount);
    } else {
      return this.upcomingMainStageEvents;
    }
  }

  handleGoToMainStage = () => {
    UIState.currentPage = PageEnums.mainstage;
  }

  render(){
    return (
      <div className="events-bar">
        <div className="bar-container" >
          {this.mainStageEvents.map((event)=><MainStageEventWidget key={event._id} firstListing={event._id===this.mainStageEvents[0]._id} event={event} onClick={this.handleGoToMainStage} />)}
          {this.moreEventsCount>0 && this.barWidth>400 && <div className="moreEvents" onClick={this.handleGoToMainStage}>{this.moreEventsNote}</div>}
          {this.mainStageEvents.length==0 &&
            <div className={"mainstage-event recordings"}>
              {this.barWidth>300 ?
                <>
                  <h2>Watch Mainstage Recordings</h2>
                  <div className={"icon"} aria-hidden={true}>
                    <Icon style={{width:'35px', height:'35px'}} iconName={'Complete'} color={'#7d83b3'} />
                  </div>
                  <div className={"info"}>
                    <p><strong>Session recordings are made available in the Feed below.</strong></p>
                    <p style={{whiteSpace:'normal'}}>It may take up to a day before recordings are posted.</p>
                  </div>
                </>
              :
              <div className={"info"}>
                  <p>Mainstage recordings are made available in the Feed below.</p>
              </div>
              }
            </div>
          }
        </div>
        <div className="action-button" >
          {this.mainStageEvents.length>0 && <IconButton label="Main Stage" style={{overflow: 'hidden'}} big onClick={this.handleGoToMainStage}>arrow_forward</IconButton>}
        </div>
      </div>
    );
  }
}



